"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable */
// Only for Http
var _default = async (_ref, res, next) => {
  let payload = _ref.payload,
      store = _ref.store;
  if (payload.method !== 'eth_subscribe') return next();
};

exports.default = _default;